export default __webpack_public_path__ + "static/extralight-47c637a05852c3c1dd0df89ccdb58adc.woff2";